<div class="modal-header">
	<button type="button" class="close" aria-label="Close" (click)="close()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>

<!-- Loader spinner begins -->
<div *ngIf="!loaders.dataSource" class="pt-5 kt-spinner kt-spinner--center kt-spinner--lg kt-spinner--dark"></div>


<!-- Loader spinner ends -->
<div  class="modal-footer" *ngIf="showButtons">
	<button mat-raised-button type="button"
			color="accent"
			(click)="aceptModal()"
			[ngClass]="{'kt-spinner kt-spinner--center kt-spinner--md kt-spinner--light': loader}"
			[disabled]="loader"
			style="min-height: 36px; position: inherit; transform: translateY(0)">
		<ng-container *ngIf="!loader">
			{{buttonMessage}}
		</ng-container>
	</button>
	<button mat-raised-button type="button" style="margin-left: 10px!important;" (click)="close()" [disabled]="loader">
	  Cancel
	</button>
</div>

<div class="modal-body complete" *ngIf="!compareView && loaders.dataSource">


	<div class="pdf-viewer-controls-wrap">

		<div class="pdf-viewer-controls row">
		  <div class="pdfv-control col-8" *ngIf="renderText">
			Search:
			<input #queryInp id="pdfQueryInput" type="text" placeholder="Search..." [value]="pdfQuery"
			  (input)="searchQueryChanged($event.target.value)" (keyup.enter)="searchQueryChanged(queryInp.value)">
			</div>
			<div class="col-2">Total Pages:{{totalPages}}</div>
			<div class="col-2">
				<span matTooltip="Zoom Out" > <i class="fa fa-minus-square fa-lg" aria-hidden="true" (click)="zoomOut()"></i> </span>
				<span style="margin-left: 5px;" matTooltip="Zoom In" > <i class="fa fa-plus-square fa-lg" aria-hidden="true" (click)="zoomIn()"></i> </span>
				<span style="margin-left: 5px;" matTooltip="Rotate"> <i class="fa fa-undo fa-lg" aria-hidden="true" (click)="rotateDoc()"></i> </span>
				<span style="margin-left: 5px;" matTooltip="Print"> <i class="fa fa fa-print fa-lg" aria-hidden="true" (click)="printPDF()"></i> </span>
			</div>

		</div>
	  </div>
	  <div class="pdf-viewer-viewer-window">
		<pdf-viewer  [src]="pathNormalView" [downloadFileName]="name" [render-text]="renderText" [render-text-mode]="renderTextMode" [rotation]="rotation"
		[zoom]="zoom" [zoom-scale]="zoomScale" [original-size]="originalSize" [fit-to-page]="fitToPage"
		[show-all]="showAll" [autoresize]="autoresize" (after-load-complete)="callBackFn($event)"
		 (error)="onError($event)" (on-progress)="onProgress($event)">
	  </pdf-viewer>

	  </div>

</div>
<div class="modal-body" *ngIf="compareView">
	<h4>Invoice:</h4>
	<!-- Loader spinner begins -->
	<div *ngIf="!loaders.pdfSource1" class="pt-5 kt-spinner kt-spinner--center kt-spinner--lg kt-spinner--dark">
	</div>
	<!-- Loader spinner ends -->
	<div class="pdf-viewer-controls-wrap">

		<div class="pdf-viewer-controls row">
		  <div class="pdfv-control col-8" *ngIf="renderText">
			Search:
			<input #queryInp id="pdfQueryInput" type="text" placeholder="Search..." [value]="pdfQuery1"
			  (input)="searchQueryChanged1($event.target.value)" (keyup.enter)="searchQueryChanged1(queryInp.value)">
			</div>
			<div class="col-2">Total Pages:{{totalPages1}}</div>
			<div class="col-2">
				<span matTooltip="Zoom Out" > <i class="fa fa-minus-square fa-lg" aria-hidden="true" (click)="zoomOut1()"></i> </span>
				<span style="margin-left: 5px;" matTooltip="Zoom In" > <i class="fa fa-plus-square fa-lg" aria-hidden="true" (click)="zoomIn1()"></i> </span>
				<span style="margin-left: 5px;" matTooltip="Rotate"> <i class="fa fa-undo fa-lg" aria-hidden="true" (click)="rotateDoc1()"></i> </span>
				<span style="margin-left: 5px;" matTooltip="Print"> <i class="fa fa fa-print fa-lg" aria-hidden="true" (click)="printPDF1()"></i> </span>
			</div>

		</div>
	  </div>
	  <div class="pdf-viewer-viewer-window">
		<pdf-viewer  *ngIf="loaders.pdfSource1" [src]="pathCompareView1" [downloadFileName]="name1" [render-text]="renderText1" [render-text-mode]="renderTextMode1" [rotation]="rotation1"
		[zoom]="zoom1" [zoom-scale]="zoomScale1" [original-size]="originalSize1" [fit-to-page]="fitToPage1"
		[show-all]="showAll1" [autoresize]="autoresize1" (after-load-complete)="callBackFn1($event)"
		 (error)="onError($event)" (on-progress)="onProgress($event)">
	  </pdf-viewer>

	  </div>

</div>
<div class="modal-body top-position" *ngIf="compareView" style="margin-top: 60px!important;">

	<h4>Purchase Order:</h4>
	<h4 *ngIf="loaders.pdfSource2">{{ po2OrderTypeString }} {{ po2DateString | date:'MM/dd/yyyy h:mm:ss' }}</h4>
	<!-- Loader spinner begins -->
	<div *ngIf="!loaders.pdfSource2" class="pt-5 kt-spinner kt-spinner--center kt-spinner--lg kt-spinner--dark">
	</div>
	<!-- Loader spinner ends -->
	<div class="pdf-viewer-controls-wrap">

		<div class="pdf-viewer-controls row">
		  <div class="pdfv-control col-8" *ngIf="renderText">
			Search:
			<input #queryInp id="pdfQueryInput" type="text" placeholder="Search..." [value]="pdfQuery2"
			  (input)="searchQueryChanged2($event.target.value)" (keyup.enter)="searchQueryChanged2(queryInp.value)">
			</div>
			<div class="col-2">Total Pages:{{totalPages}}</div>
			<div class="col-2">
				<span matTooltip="Zoom Out" > <i class="fa fa-minus-square fa-lg" aria-hidden="true" (click)="zoomOut2()"></i> </span>
				<span style="margin-left: 5px;" matTooltip="Zoom In" > <i class="fa fa-plus-square fa-lg" aria-hidden="true" (click)="zoomIn2()"></i> </span>
				<span style="margin-left: 5px;" matTooltip="Rotate"> <i class="fa fa-undo fa-lg" aria-hidden="true" (click)="rotateDoc2()"></i> </span>
				<span style="margin-left: 5px;" matTooltip="Print"> <i class="fa fa fa-print fa-lg" aria-hidden="true" (click)="printPDF2()"></i> </span>
			</div>

		</div>
	  </div>
	  <div class="pdf-viewer-viewer-window">
		<pdf-viewer  *ngIf="loaders.pdfSource2" [src]="pathCompareView2" [downloadFileName]="name2" [render-text]="renderText2" [render-text-mode]="renderTextMode2" [rotation]="rotation2"
		[zoom]="zoom2" [zoom-scale]="zoomScale2" [original-size]="originalSize2" [fit-to-page]="fitToPage2"
		[show-all]="showAll2" [autoresize]="autoresize2" (after-load-complete)="callBackFn2($event)"
		 (error)="onError($event)" (on-progress)="onProgress($event)">
	  </pdf-viewer>

	  </div>
</div>

